import { toProductCategory } from '@/api/mappers/mapProductCategory';
import { toApiStatus } from '@/api/mappers/mapStatus';
import {
  Product as ApiProduct,
  ProductCreate as ApiProductCreate,
  ProductListResponse as ApiProductListResponse,
} from '@/gen/api';
import { Product, ProductCreate, Products } from '@/models/Product';

export function toProduct(apiProduct: ApiProduct): Product {
  return {
    ...apiProduct,
    productCategory: apiProduct.productCategory
      ? toProductCategory(apiProduct.productCategory)
      : undefined,
  };
}

export function toProducts(response: ApiProductListResponse): Products {
  return {
    items: response.items.map(toProduct),
    totalCount: response.totalCount,
    estimatedTotalCount: response.estimatedTotalCount,
  };
}

export function toApiProduct(product: Product): ApiProduct {
  return {
    ...product,
    name: product.name ?? '',
    description: product.description ?? '',
    status: toApiStatus(product.status),
    productCategory: undefined,
  };
}

export function toApiProductCreate(product: ProductCreate): ApiProductCreate {
  return {
    name: product.name,
    description: product.description,
    gtin: product.gtin,
    vatRate: product.vatRate,
    productCategoryId: product.productCategoryId,
  };
}
